/* tslint:disable */
import {
  PartnerAddress,
  PartnerLerProduct,
  ResiduePartnerKPI,
  LerOperatorType
} from '../index';

declare var Object: any;
export interface PartnerInterface {
  "id"?: number;
  "name"?: string;
  "active"?: boolean;
  "ler_operator_type_id"?: number;
  "kpi_list"?: Array<any>;
  "address"?: number;
  "partner_ler_product_list"?: Array<any>;
  partnerAddress?: PartnerAddress;
  products?: PartnerLerProduct[];
  kpi?: ResiduePartnerKPI[];
  ler_operator_type?: LerOperatorType;
}

export class Partner implements PartnerInterface {
  "id": number;
  "name": string;
  "active": boolean;
  "ler_operator_type_id": number;
  "kpi_list": Array<any>;
  "address": number;
  "partner_ler_product_list": Array<any>;
  partnerAddress: PartnerAddress;
  products: PartnerLerProduct[];
  kpi: ResiduePartnerKPI[];
  ler_operator_type: LerOperatorType;
  constructor(data?: PartnerInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Partner`.
   */
  public static getModelName() {
    return "Partner";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Partner for dynamic purposes.
  **/
  public static factory(data: PartnerInterface): Partner{
    return new Partner(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Partner',
      plural: 'Partners',
      path: 'Partners',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "active": {
          name: 'active',
          type: 'boolean'
        },
        "ler_operator_type_id": {
          name: 'ler_operator_type_id',
          type: 'number'
        },
        "kpi_list": {
          name: 'kpi_list',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "address": {
          name: 'address',
          type: 'number'
        },
        "partner_ler_product_list": {
          name: 'partner_ler_product_list',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
      },
      relations: {
        partnerAddress: {
          name: 'partnerAddress',
          type: 'PartnerAddress',
          model: 'PartnerAddress',
          relationType: 'belongsTo',
                  keyFrom: 'address',
          keyTo: 'id'
        },
        products: {
          name: 'products',
          type: 'PartnerLerProduct[]',
          model: 'PartnerLerProduct',
          relationType: 'referencesMany',
                  keyFrom: 'partner_ler_product_list',
          keyTo: 'id'
        },
        kpi: {
          name: 'kpi',
          type: 'ResiduePartnerKPI[]',
          model: 'ResiduePartnerKPI',
          relationType: 'referencesMany',
                  keyFrom: 'kpi_list',
          keyTo: 'id'
        },
        ler_operator_type: {
          name: 'ler_operator_type',
          type: 'LerOperatorType',
          model: 'LerOperatorType',
          relationType: 'belongsTo',
                  keyFrom: 'ler_operator_type_id',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Partner.ts